import { render, staticRenderFns } from "./GoogleRatingSelector.vue?vue&type=template&id=6502177a&scoped=true"
import script from "./GoogleRatingSelector.vue?vue&type=script&lang=js"
export * from "./GoogleRatingSelector.vue?vue&type=script&lang=js"
import style0 from "./GoogleRatingSelector.vue?vue&type=style&index=0&id=6502177a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502177a",
  null
  
)

export default component.exports